import { publishEvent } from './publishers';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ProcessType } from 'shared/domain/process/types/model';
import { processContract } from 'shared/domain/process/processContract';

/** Outcome of a workflow change, with its `uniqueId`. */
export function broadcastUpdatedProcess(process: ProcessType, uniqueId: string): void {
  publishEvent(processContract, DomainMessagesTypes.updatedProcess, process, { uniqueId });
}

/** `uniqueId` of the failed change lets its command reject with this error and `messageId`. */
export function broadcastProcessError(error: unknown, uniqueId: string, messageId?: string): void {
  publishEvent(processContract, DomainMessagesTypes.processError, undefined, {
    uniqueId,
    error,
    messageId,
  });
}

export function broadcastAllProcesses(processes: ProcessType[], hasAll: boolean): void {
  publishEvent(processContract, DomainMessagesTypes.allProcesses, { hasAll, items: processes });
}
